import { Text } from '@hotjar/hotsauce';
import type { ContextOfUse, DateRange, FilterType } from '@hotjar/global-filters';
import type { PlanComparisonReferrer } from '@hotjar/webapp/features/Billing/PlanComparisonModal/types';
import type { AdditionalTrackingData, FilterChainSeries } from '@hotjar/dashboard-quantz';
import { useTranslation } from 'react-i18next';
import { OneFilterChain } from './OneFilterChain';
import { Steps } from '../../../TrendsPage/Steps';
import { DeleteButton } from '../../../TrendsPage/DeleteButton';

interface OneFilterWrapperProps {
  filterChainSeries: FilterChainSeries;
  dateRange?: DateRange;
  isDeletable: boolean;
  isFirstChain: boolean;
  isLastChain: boolean;
  isFiltersDropdownVisibleByDefault: boolean;
  hideHeaderLabel?: boolean;
  contextOfUse: ContextOfUse;
  onFiltersChange: (filtersInUiFormat: FilterType[], dateRange?: DateRange) => void;
  onUpsellRequest: (
    featureName: PlanComparisonReferrer,
    additionalTrackingData?: AdditionalTrackingData,
  ) => void;
  onChainDelete: () => void;
  trackClick: (eventName: string, additionalTrackingData: AdditionalTrackingData) => void;
}

export const OneFilterWrapper = ({
  filterChainSeries,
  dateRange,
  isDeletable,
  isFirstChain,
  isLastChain,
  isFiltersDropdownVisibleByDefault,
  hideHeaderLabel,
  contextOfUse,
  onFiltersChange,
  onUpsellRequest,
  onChainDelete,
  trackClick,
}: OneFilterWrapperProps): JSX.Element => {
  const { t } = useTranslation('dashboard-quantz');
  return (
    <Steps.Step
      isFirstChain={isFirstChain}
      isLastChain={isLastChain}
      stepMarker={{ kind: 'dot', color: filterChainSeries.color }}
    >
      {hideHeaderLabel !== true && (
        <div>
          <Text textType="subtitle2">{t`TrendView.allSession.1`}</Text>
          <Text textColor="text_light">{t`TrendView.allSession.2`}</Text>
        </div>
      )}
      <OneFilterChain
        currentFiltersInUiFormat={{
          dateRange,
          filterList: filterChainSeries.filtersInUiFormat,
        }}
        isFiltersDropdownVisibleByDefault={isFiltersDropdownVisibleByDefault}
        onFiltersChange={(filterInUiFormat) =>
          onFiltersChange(filterInUiFormat.filterList, filterInUiFormat.dateRange)
        }
        onUpsellRequest={onUpsellRequest}
        contextOfUse={contextOfUse}
      />
      {isDeletable && (
        <DeleteButton
          onClick={() => {
            trackClick('cleared_filters_group_comparison', {
              ui_position: contextOfUse.page,
              state_event_was_triggered_on: contextOfUse.page,
              element_name: 'cleared_filters_group_comparison',
            });
            onChainDelete();
          }}
          tooltipText={t('step.remove')}
        />
      )}
    </Steps.Step>
  );
};
